import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarEight: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M20.2642 20.8725V18.6089C20.2642 18.0406 19.8126 17.58 19.2555 17.58H18.4485C17.8914 17.58 17.4398 17.1193 17.4398 16.5511V15.8823C17.4398 15.3141 16.9882 14.8534 16.4311 14.8534H14.123V17.6989H16.4325C16.9896 17.6989 17.4398 18.195 17.4398 18.7632V20.8725H20.2642Z"
      fill={color}
    />
    <path
      d="M16.5541 26.022H9.83308C9.27598 26.022 8.82436 25.5802 8.82436 25.012V24.3432C8.82436 23.775 8.37273 23.3143 7.81564 23.3143H7.00869C6.45159 23.3143 5.99997 22.8536 6 22.2854L6 9.90189C6 9.33798 6.4551 8.88086 7.01647 8.88086H7.62635C8.18775 8.88086 8.64282 8.42373 8.64282 7.85983V7.043C8.64282 6.4791 9.09792 6.02197 9.65932 6.02197L16.6128 6.02197C17.1742 6.02197 17.6293 6.4791 17.6293 7.043V7.85983C17.6293 8.42373 17.1742 8.88086 16.6128 8.88086L9.8626 8.88086C9.30123 8.88086 8.84613 9.33798 8.84613 9.90189L8.84613 13.8189C8.84613 14.3828 9.30123 14.84 9.8626 14.84L15.8665 14.8534L15.8665 17.6989L9.86261 17.6989C9.30123 17.6989 8.84613 18.156 8.84613 18.7199L8.84613 21.9403H8.8452V22.1311C8.8452 22.6993 9.27598 23.16 9.83308 23.16H14.1948V23.1631H16.4016C16.963 23.1631 17.4398 22.7055 17.4398 22.1416V19.383H20.2642V22.1421C20.2642 22.706 19.8091 23.1631 19.2477 23.1631H18.587C18.0256 23.1631 17.5705 23.6202 17.5705 24.1841V25.0009C17.5705 25.5648 17.1155 26.022 16.5541 26.022Z"
      fill={color}
    />
    <path
      d="M11.7358 20.8725L11.7358 18.6089C11.7358 18.0406 12.1874 17.58 12.7445 17.58H13.5515C14.1086 17.58 14.5602 17.1193 14.5602 16.5511V15.8823C14.5602 15.3141 15.0118 14.8534 15.5689 14.8534L17.877 14.8534L17.877 17.6989L15.5675 17.6989C15.0104 17.6989 14.5602 18.195 14.5602 18.7632V20.8725H11.7358Z"
      fill={color}
    />
    <path
      d="M15.4459 26.022H22.1669C22.724 26.022 23.1756 25.5802 23.1756 25.012V24.3432C23.1756 23.775 23.6273 23.3143 24.1844 23.3143H24.9913C25.5484 23.3143 26 22.8536 26 22.2854L26 9.90188C26 9.33798 25.5449 8.88085 24.9835 8.88085H24.3736C23.8122 8.88085 23.3572 8.42373 23.3572 7.85983V7.043C23.3572 6.4791 22.9021 6.02197 22.3407 6.02197L15.3872 6.02197C14.8258 6.02197 14.3707 6.4791 14.3707 7.043V7.85983C14.3707 8.42373 14.8258 8.88086 15.3872 8.88086L22.1374 8.88085C22.6988 8.88085 23.1539 9.33798 23.1539 9.90188V13.8189C23.1539 14.3828 22.6988 14.84 22.1374 14.84L16.1335 14.8534L16.1335 17.6989L22.1374 17.6989C22.6988 17.6989 23.1539 18.156 23.1539 18.7199L23.1539 21.9402H23.1548V22.1311C23.1548 22.6993 22.724 23.16 22.1669 23.16H17.8052V23.1631H15.5984C15.037 23.1631 14.5602 22.7055 14.5602 22.1416V19.383H11.7358L11.7358 22.1421C11.7358 22.706 12.1909 23.1631 12.7523 23.1631H13.413C13.9744 23.1631 14.4295 23.6202 14.4295 24.1841V25.0009C14.4295 25.5648 14.8845 26.022 15.4459 26.022Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.93842 11.7877C9.93842 12.3516 10.3935 12.8087 10.9549 12.8087H11.7681C12.3295 12.8087 12.7845 12.3516 12.7845 11.7877V10.9198C12.7845 10.3559 12.3295 9.89881 11.7681 9.89881H10.9549C10.3935 9.89881 9.93842 10.3559 9.93842 10.9198V11.7877Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.52 11.7877C19.52 12.3516 19.9751 12.8087 20.5365 12.8087H21.3497C21.9111 12.8087 22.3662 12.3516 22.3662 11.7877V10.9198C22.3662 10.3559 21.9111 9.89881 21.3497 9.89881H20.5365C19.9751 9.89881 19.52 10.3559 19.52 10.9198V11.7877Z"
      fill={color}
    />
  </svg>
);

export default AvatarEight;
